var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("questions", {
    attrs: {
      stay_id: _vm.stay_id,
      parentObject: _vm.speciality,
      category: _vm.QuestionCategory.MDT
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }